module.exports = __webpack_public_path__ + "img/headset-landing.44a7d323.png";